import { render, staticRenderFns } from "./transferModal.vue?vue&type=template&id=7d56ee76"
import script from "./transferModal.vue?vue&type=script&lang=js"
export * from "./transferModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports